import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547b36c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-block" }
const _hoisted_2 = { class: "attention" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 並び順は、 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" グループ分け設定 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" で変更してください。 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_8 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" 登録されているチームで、" + _toDisplayString(_ctx.name) + "を作成します。", 1),
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        to: {
          name: 'seasonGroupDetail',
          params: {topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, group_id: _ctx.$route.query.group } }
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_6
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "empty-add-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickCreateButton && _ctx.onClickCreateButton(...args)))
    }, [
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.name) + "を作成する", 1)
    ])
  ]))
}